import React from 'react';
import { Box, Flex, Table, Heading, Text } from '@radix-ui/themes';
import NoData from 'components/common/noData';
import { selectUserSelectedLocal, selectUserSelectedLocalCode, selectDevice } from 'store/slices/common';
import { useSelector } from 'react-redux';
import { mapLongdescList } from 'app/constants';

const OrganizationChart = ({ localData }) => {
  const userSelectedLocalCode = useSelector(selectUserSelectedLocalCode);
  const userSelectedLocal = useSelector(selectUserSelectedLocal);
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  // 웹접근성 조직도 이미지 계층 선형화 위한 데이터
  const orgData = {
    GW: {
      region: '강원',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['강원특별자치도', '춘천시', '원주시', '강릉시'],
      주관기관: '강릉과학산업진흥원(GSIPA)',
      참여기관: '주식회사 네페스',
      사업운영: '강원센터 미래채움'
    },
    GG: {
      region: '경기',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['경기도'],
      주관기관: '경기도경제과학진흥원(GBSA)',
      참여기관: '한국정보과학진흥협회(KISE)',
      사업운영: '경기센터 미래채움'
    },
    GN: {
      region: '경남',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['경상남도'],
      주관기관: '경남테크노파크(Gyeongnam Technopark)',
      참여기관: '새미래행복교육 사회적협동조합',
      사업운영: '경남센터 미래채움'
    },
    GB: {
      region: '경북',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['경상북도', '포항시', '안동시', '경산시'],
      주관기관: '경북디지털혁신본부(Gyeongbuk Digital Innovation Agency)',
      참여기관: '경북ICT융합산업진흥협회(GBICT)',
      사업운영: '경북센터 미래채움'
    },
    GJ: {
      region: '광주',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['광주광역시', '광주광역시교육청'],
      주관기관: '광주정보문화산업진흥원(GICON)',
      참여기관: '유메이커스(U-MAKERS)',
      사업운영: '광주센터 미래채움'
    },
    DG: {
      region: '대구',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['대구광역시'],
      주관기관: '대구디지털혁신진흥원(DIP)',
      참여기관: '계명대학교 산학협력단, 라인교육개발',
      사업운영: '대구센터 미래채움'
    },
    US: {
      region: '울산',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['울산광역시'],
      주관기관: '울산정보산업진흥원(UIPA)',
      참여기관: 'TNS EDUCATION',
      사업운영: '울산센터 미래채움'
    },
    IC: {
      region: '인천',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['인천광역시교육청', '강화군'],
      주관기관: '인천테크노파크(ITP)',
      참여기관: null,
      사업운영: '인천센터 미래채움'
    },
    JN: {
      region: '전남',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['전라남도', '나주시', '전라남도교육청'],
      주관기관: '(재)전남정보문화산업진흥원(JOIA)',
      참여기관: null,
      사업운영: '전남센터 미래채움'
    },
    JB: {
      region: '전북',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['전북특별자치도', '남원시'],
      주관기관: '(재)전북테크노파크(JBTP)',
      참여기관: 'PLAYCODING',
      사업운영: '전북센터 미래채움'
    },
    JJ: {
      region: '제주',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['제주특별자치도'],
      주관기관: 'TMD교육그룹',
      참여기관: '제주에스더블유강사협동조합',
      사업운영: '제주센터 미래채움'
    },
    CN: {
      region: '충남',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: ['충청남도'],
      주관기관: '남서울대학교',
      참여기관: '나우두리(공주교육대학교)',
      사업운영: '충남센터 미래채움'
    },
    CB: {
      region: '충북',
      총괄부처: '과학기술정보통신부',
      전담기관: '정보통신산업진흥원(NIPA)',
      정책지정: 'EBS, 지역SW산업발전협의회',
      지방자치단체: [
        '충청북도',
        '청주시',
        '충주시',
        '제천시',
        '보은군',
        '옥천군',
        '영동군',
        '증평군',
        '진천군',
        '괴산군',
        '음성군',
        '단양군'
      ],
      주관기관: '충북과학기술혁신원(cbist)',
      참여기관: 'Blue Communication',
      사업운영: '충북센터 미래채움'
    }
  };

  const currentOrg = orgData[userSelectedLocalCode];

  return (
    <>
      <Box mt={isMobile ? 'var(--space-6)' : 'var(--space-12)'} className="organization-img-box">
        <Flex justify="center" className="section-inner">
          <div className="image-wrap organization">
            <figure>
              <img src={localData?.diagramUrl} alt={`${userSelectedLocal} 센터 조직도`} />
              <figcaption>{mapLongdescList[userSelectedLocalCode]}</figcaption>
            </figure>
            {currentOrg && (
              <ul className="visually-hidden">
                <li>
                  총괄부처: {currentOrg.총괄부처}
                  <ul>
                    <li>
                      전담기관: {currentOrg.전담기관}
                      <ul>
                        <li>정책지정: {currentOrg.정책지정}</li>
                        <li>
                          지방자치단체
                          <ul>
                            {currentOrg.지방자치단체.map(name => (
                              <li key={name}>{name}</li>
                            ))}
                          </ul>
                        </li>
                        <li>
                          주관기관: {currentOrg.주관기관}
                          <ul>
                            {currentOrg.참여기관 && <li>참여기관: {currentOrg.참여기관}</li>}
                            <li>사업운영: {currentOrg.사업운영}</li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </div>
        </Flex>
      </Box>

      {localData?.details ? (
        localData.details?.map((item, index) => (
          <Box pt={isMobile ? 'var(--space-6)' : 'var(--space-15)'} className="table-wrap" key={index}>
            <Box mb={isMobile ? 'var(--space-4)' : 'var(--space-6)'}>
              <Text as="p" className={isMobile ? 'sub-title' : 'title4'}>
                {item.orgName}
              </Text>
              <Text as="p" className={isMobile ? 'body2 font-bold' : 'sub-title'}>
                {item.orgInfo}
              </Text>
            </Box>
            <Table.Root layout={'auto'} className="data-table">
              <caption>{`${userSelectedLocal} ${item.orgInfo} 테이블`}</caption>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && 'var(--space-25)'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    직책
                  </Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && 'var(--space-30)'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    이름
                  </Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && '200px'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    전화번호
                  </Table.ColumnHeaderCell>
                  {/*<Table.ColumnHeaderCell*/}
                  {/*  justify="center"*/}
                  {/*  py="var(--space-5)"*/}
                  {/*  className={isMobile ? "body3 font-bold" : "sub-title"}*/}
                  {/*  width="200px"*/}
                  {/*>*/}
                  {/*  이메일*/}
                  {/*</Table.ColumnHeaderCell>*/}
                  <Table.ColumnHeaderCell justify="center" className={isMobile ? 'body3 font-bold' : 'sub-title'}>
                    업무내용
                  </Table.ColumnHeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {item.managers?.map((manager, index) => (
                  <Table.Row key={index}>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.rank || '-'}
                    </Table.Cell>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.name || '-'}
                    </Table.Cell>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.phone || '-'}
                    </Table.Cell>
                    {/*<Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>*/}
                    {/*  {manager.email}*/}
                    {/*</Table.Cell>*/}
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.duty}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Root>
          </Box>
        ))
      ) : (
        <NoData />
      )}
    </>
  );
};

export default OrganizationChart;
